export default __webpack_public_path__ + "static/media/forumDeDuvidas.6f3bfd23.png";